import { createSelector } from 'reselect';

import getDeliveryOrderLeadTimes from './getDeliveryOrderLeadTimes';
import getAverageAsapDeliveryTime from './getAverageAsapDeliveryTime';

/**
 * # getDeliveryAsapDurationWorstCaseScenario
 *
 * Gets the worst case delivery duration for ASAP delivery.
 * This is used in the helper text below the ASAP option to give the
 * user a rough estimate if they pick ASAP.
 */
export default createSelector(
  [getDeliveryOrderLeadTimes, getAverageAsapDeliveryTime],
  (deliveryOrderLeadTimes, averageAsapDeliveryDuration) => {
    const storeMap: Record<number, OrderLeadTime[]> = {};

    deliveryOrderLeadTimes.forEach(rule => {
      if (!storeMap[rule.StoreID]) {
        storeMap[rule.StoreID] = [];
      }
      storeMap[rule.StoreID].push(rule);
    });

    let maxLeadTime = 0;

    for (const storeId in storeMap) {
      const rules = storeMap[storeId].sort(
        (a, b) => a.MoneyLower - b.MoneyLower,
      );

      const totalTime = rules.reduce((sum, rule) => sum + rule.Time, 0);
      if (totalTime > maxLeadTime) {
        maxLeadTime = totalTime;
      }
    }

    return maxLeadTime + averageAsapDeliveryDuration;
  },
);
